import { Suspense, useEffect } from 'react';
import { Outlet } from 'react-router';
import Header from '@/components/Header/index';
import { SidebarProvider } from '@/components/ui/sidebar';
import { AppSidebar } from '@/components/Sidebar/app-sidebar';
import { usePermission } from '@/services/permission.service';
import { useRootSelector } from '@/hooks/selector.hook';
import { MOCK_MENU } from '@/constants/mock-menu';
import { Skeleton } from '@/components/ui/skeleton';

export default function MainLayout() {
  const { getAllMenuPermission } = usePermission();
  const customerId = useRootSelector((state) => state.auth.customerId);
  const menuFromApi = useRootSelector((state) => state.permission.menuItems);
  // Enterprise backend has no menu API yet — fall back to the legacy-shaped mock
  // (only notification / eKYC entries enabled).
  const dataMenu = menuFromApi?.length ? menuFromApi : MOCK_MENU;
  // Gọi API permission khi layout mount và có customerId
  useEffect(() => {
    if (customerId) {
      getAllMenuPermission();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerId]); // Chỉ depend vào customerId, không depend vào getAllMenuPermission để tránh re-render

  return (
    <div className="min-h-screen overflow-x-hidden bg-secondary">
      <SidebarProvider>
        <AppSidebar data={dataMenu} />
        <div className="min-w-0 flex-1">
          <div className="min-h-screen transition-all duration-300">
            {/* Header */}
            <Header />

            {/* Page Content */}
            <main className="px-[0.8rem] pb-[2rem] pt-[2rem] lg:px-[3rem]">
              <Suspense
                fallback={
                  <div className="space-y-[1.2rem] py-[2rem]">
                    <Skeleton className="h-[3.2rem] w-[18rem]" />
                    <Skeleton className="h-[12rem] w-full" />
                    <Skeleton className="h-[24rem] w-full" />
                  </div>
                }
              >
                <Outlet />
              </Suspense>
            </main>
          </div>
        </div>
      </SidebarProvider>
    </div>
  );
}
